<template>
    <div>
        <div class="flex">
            <label v-show="label" class="label" :style="labelStyle">
                <span v-if="required" class="col-red">*</span>    
                {{label}}
            </label>
            <el-autocomplete
                v-if="remote"
                v-model.trim="iptVal"
                @keyup.enter.native="enterHandle('iptVal')"
                :fetch-suggestions="querySearchAsync"
                :placeholder="placeholder?placeholder:'请输入'+label"
                @select="selectHandle"
            ></el-autocomplete>

            <el-input 
                v-if="!remote"
                v-model.trim="iptVal"
                :placeholder="placeholder?placeholder:'请输入'+label"
                :disabled="disabled"
                :clearable="clearable"
                :size="size"
                :type="iptType"
                :autoComplete="autoComplete"
                :style="inputStyle"
                :min="min"
                :max="max"
                :rows="iptType==='textarea'?rows:false"
                @keyup.enter.native="enterHandle('iptVal')"
                @blur="blurHandle"
            ></el-input>

            <!-- <template v-if="tag || tagType || tagSize">
                <el-tag
                    class="ml10"
                    v-for="tag in tagList"
                    :key="tag.name"
                    closable
                    :type="tag.type || tagType"
                    @close="colseTag(tag.name)">
                    {{tag.name}}
                </el-tag>
            </template> -->
        </div>

        <div v-if="tag || tagType || tagSize">
            <el-tag
            class="mr20 mb10"
            v-for="tag in tagList"
            :key="tag.name"
            closable
            :type="tag.type || tagType"
            :size="tagSize"
            @close="colseTag(tag.name)">
                {{tag.name}}
            </el-tag>
        </div>
    </div>
</template>
<style scoped>
    .label{
        min-width: 85px;
        text-align: right;
        /* display: inline-block; */
        padding: 0 10px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
</style>
<script>
import {
    autocomplete,
    tag,
    input
} from 'element-ui'
export default {
    name:'inputBox',
    // model:{
    //     prop: "iptval",
    //     event: "input"
    // },
    props:{
        remote:{
            type:Boolean,
            defualt:false
        },
        // 远程actions名称
        reMoteType:{
            type: String
        },
        label:{
            type:String,
            default:''
        },
        labelStyle:{
            type:[Object,String]
        },
        placeholder:{
            type:String,
        },
        tag:{
            type:Boolean,
            default:false
        },
        tagType:{
            type:String,
            default:''
        },
        tagSize:{
            type:String,
            default:''
        },
        tagList:{
            type:Array,
            default:()=>{
                return []
            }
        },
        // ipt 
        required:{
            type: Boolean,
            default: false
        },
        disabled:{
            type:Boolean,
            default:false
        },
        clearable:{
            type:Boolean,
            default:false
        },
        iptType:{
            type:String,
            default:'text'
        },
        inputStyle:{
            type:[String,Object]
        },
        val:{
            type:[String,Number]
        },
        size:{
            type:String
        },
        value:{
            type:[String,Number]
        },
        autoComplete:{
            type:String
        },
        min:{
            default:null
        },
        max:{
            default:null
        },
        rows:{
            default: 5
        }
    },
    computed:{
        iptVal:{
            get(){
                return this.value;
            },
            set(v){
                // console.log(v)
                this.$emit('input',v);
            }
        }
            
    },
    data(){
        return {
            // autoVal:''
            // val:''
        }
    },
    methods:{
        querySearchAsync(queryString, cb) {
            // 远程搜索
            let _this = this;
            if (!queryString) return false;
            this.$store.dispatch( _this.reMoteType, {keyword:queryString} ).then(dt=>{
                let results = dt.map(v=>{
                    return {
                        value:v.index_word
                    }
                })
                cb(results)
            })
        },
        selectHandle(item) {
            //联想选择 插入tag
            this.setTagList(item.value);
        },
        // 关闭标签
        colseTag(tagname){
            let tagarr = Object.assign(this.tagList);
            let ind = tagarr.findIndex(v=> { return v.name === tagname});
            tagarr.splice(ind,1);
            this.$emit('tagChangeEvent',tagarr);
        },
        // ipt输入
        inputHandle(v){
            this.$emit('input',v);
        },
        enterHandle(t){
            this.setTagList(this[t],t);
        },
        // tag 插入
        setTagList(v,t){
            if(!v)return false;
            if( this.tag || this.tagType || this.tagSize ){
                let tagarr = Object.assign(this.tagList);
                let hasTag = !!(tagarr.filter(o=>o.name === v).length);
                !hasTag && tagarr.push({
                    name:v,
                    // type:'success'
                })
                this[t] = '';
                this.$emit('tagChangeEvent',tagarr);
            }else{
                // 回车 下拉选中
                this.$emit('enterEvent',v)
            }
        },
        blurHandle(){
            // console.log(this.iptVal)
            this.$emit('blur',this.iptVal)
        }
    },
    components:{
        elAutocomplete:autocomplete,
        elTag:tag,
        elInput:input
    }
}
</script>


// WEBPACK FOOTER //
// src/components/inputBox.vue